import getToken from "../../utility/Authentication";
import fetchWithTimeout from "../../utility/fetch";
import getUrl from "../../utility/getUrl";
import { AuthenticationInfoType } from "../../utility/types";

const SetOrganizationNames = async (auth: AuthenticationInfoType, results: any[]) => {
  var allOrganizations: Record<string, string> = JSON.parse(localStorage.getItem("organizationNameMap") || "{}");

  const organizationIds = getOrganizationIds(results);

  const neededOrganizationIds = organizationIds.filter((v) => v !== "" && allOrganizations[v] === undefined);

  if (neededOrganizationIds.length > 0) {
    const organizationNameMap = await fetchOrganizationNameMap(auth, neededOrganizationIds);
    allOrganizations = { ...allOrganizations, ...organizationNameMap };

    localStorage.setItem("organizationNameMap", JSON.stringify(allOrganizations));
  }

  return results.map((result) => {
    if (result.header.organizationId) {
      const orgName = allOrganizations[result.header.organizationId];
      return {
        ...result,
        header: {
          ...result.header,
          organizationName: orgName,
        },
      };
    } else {
      return result;
    }
  });
};

function getOrganizationIds(results: any[]) {
  const idSet = new Set<string>();

  results.forEach((r) => {
    idSet.add(r.header.organizationId || "");
  });

  return [...idSet];
}

async function fetchOrganizationNameMap(auth: AuthenticationInfoType, organizationIds: string[]) {
  const url = getUrl("organizationMap");

  const payload = { ids: organizationIds };
  const options = {
    method: "POST",
    headers: new Headers({
      Authorization: getToken(auth),
      "Content-Type": "application/json",
    }),
    body: JSON.stringify(payload),
  };

  const response = await fetchWithTimeout(url, options);
  if (response.ok) {
    const orgNameMap: Record<string, string> = await response.json();
    return orgNameMap;
  } else {
    throw new Error(response.statusText);
  }
}

export { SetOrganizationNames };
